export default __webpack_public_path__ + "static/slider2-c6ddd2322ceb33ec2fd10c2aab631dda.jpg";